<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Edit Crypto Rate</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <custom-form
          :fields="cryptoRate"
          :action="url"
          method="put"
          @submitted="$emit('rateUpdated', $event)"
        >
          <custom-select
            name="crypto_country_id"
            class="form-group"
            label="Crypto Country"
            :items="cryptoCountries"
          />
          <custom-select
            name="local_currency_id"
            class="form-group"
            label="Local Currency"
            :items="traditionalCurrencyOptions"
          />
          <custom-select
            name="crypto_currency_id"
            class="form-group"
            label="Crypto Currency"
            :items="cryptoCurrencyOptions"
          />
          <custom-select
            name="reference_currency_id"
            class="form-group"
            label="Reference Currency"
            :items="traditionalCurrencyOptions"
          />
          <custom-input name="reference_to_local_rate" label="Reference to local Rate" />

          <custom-input name="reference_to_crypto_rate" label="Reference to crypto Rate" />

          <custom-input name="min_crypto_amount" label="Minimum Crypto Amount" />

          <custom-input name="max_crypto_amount" label="Maximum Crypto Amount" />

          <custom-button color="primary" large raised tile block>
            <v-icon>mdi-file-edit</v-icon>
            Edit Rate
          </custom-button>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    cryptoRate: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      currencies: {
        crypto: [],
        traditional: [],
      },
      countries: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    url() {
      return `api/v1/cryptoRates/${this.cryptoRate.id}`;
    },
    cryptoCountries() {
      return this.getSelectOptions(this.countries);
    },
    traditionalCurrencyOptions() {
      return this.getSelectOptions(this.currencies.traditional);
    },
    cryptoCurrencyOptions() {
      return this.getSelectOptions(this.currencies.crypto);
    },
  },
  methods: {
    getSelectOptions(data) {
      return data.map(({ id, name }) => ({ value: id, text: name }));
    },
    fetchData() {
      this.$http.get("/api/v1/currencies").then((currencies) => {
        this.currencies = currencies;
      });
      this.$http.get("/api/v1/transactions/cryptoCountries").then(({ data }) => {
        this.countries = data;
      });
    },
  },
};
</script>
